import Event from '../../core/Event';

export default class OrderSetBaseOnLiabilityFailed extends Event {
    public static type = 'OrderSetBaseOnLiabilityFailed';

    constructor() {
        super(OrderSetBaseOnLiabilityFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderSetBaseOnLiabilityFailed.ts